import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfiguratorCredentialsComponent } from './configurator-credentials.component';
import {ActionBarModule} from '../../../components/action-bar/action-bar.module';
import {ArmTableModule} from '../../../components/arm-table/arm-table.module';
import { UsedInElementsPipe } from './used-in-elements.pipe';
import { ConfiguratorCredentialsDialogComponent } from './configurator-credentials-dialog/configurator-credentials-dialog.component';
import {MaterialModule} from '../../../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InfraModule} from 'ac-infra';



@NgModule({
  declarations: [ConfiguratorCredentialsComponent, UsedInElementsPipe, ConfiguratorCredentialsDialogComponent],
  imports: [
    CommonModule,
    ActionBarModule,
    ArmTableModule,
    MaterialModule,
    FormsModule,
    InfraModule,
    ReactiveFormsModule
  ]
})
export class ConfiguratorCredentialsModule { }
